import { useEffect, useState } from "react";
import { Outlet, useLocation, useRouteLoaderData } from "react-router-dom";
import SideBar from "../../components/SideBar";
import { ReportParamsContext } from "../../context/ReportParamsContext";
import ReportParametersSelector from "../../components/ReportParametersSelector";

const ROUTES_WITHOUT_PARAMS = ["task_report"];

// Reports a MANUFACTURER-role session may access. Keep in sync with the allow-list
// in SecurityConfig.java (backend enforces this regardless of what the UI shows).
export const MANUFACTURER_ALLOWED_REPORTS = [
  "distribution_by_banner_by_item",
  "total_distribution_by_banner",
  "stock_level_summary",
  "monthly_merchandising",
  "banner_by_month",
];

export default function ReportsLayout({ sideBarItems }) {
  const location = useLocation();
  const auth = useRouteLoaderData("markit");
  const isManufacturer = auth?.type === "MANUFACTURER";
  const visibleSideBarItems = isManufacturer
    ? sideBarItems.filter((item) => MANUFACTURER_ALLOWED_REPORTS.includes(item.href))
    : sideBarItems;
  const hideParams = ROUTES_WITHOUT_PARAMS.some((r) => location.pathname.endsWith(r));
  const [searchText, setSearchText] = useState("");
  const [commonParams, setCommonParams] = useState({
    manufacturer: isManufacturer ? { id: auth.manufacturerId, name: auth.manufacturerName } : null,
    fromDate: "",
    toDate: "",
    provinces: [],
    territories: [],
    representatives: [],
    itemStatus: "ACTIVE",
  });

  useEffect(() => {
    if (isManufacturer) {
      setCommonParams((prev) => ({ ...prev, manufacturer: { id: auth.manufacturerId, name: auth.manufacturerName } }));
    }
  }, [isManufacturer, auth?.manufacturerId, auth?.manufacturerName]);

  return (
    <>
      <SideBar items={visibleSideBarItems} />
      <ReportParamsContext.Provider value={[commonParams, setCommonParams]}>
        <div className="d-flex flex-column flex-grow-1 overflow-hidden">
          {!hideParams && <ReportParametersSelector />}
          <Outlet context={[searchText, setSearchText]} />
        </div>
      </ReportParamsContext.Provider>
    </>
  );
}
